/* Zorina Mast — bočna košarica (drawer). Preporuke: Search & Discovery (/recommendations/products). */
(function () {
  'use strict';
  if (customElements.get('zm-cart-drawer')) return;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };

  class ZMCart extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-zmc-config]').textContent); } catch (e) { this.cfg = {}; }
      this.$ = function (s) { return this.querySelector(s); }.bind(this);
      this.panel = this.$('.zmc__panel');
      this.recsCache = {};
      this.busy = false;
      var self = this;

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-zmc-close]')) { e.preventDefault(); self.close(); return; }
        var q = e.target.closest('[data-zmc-qty]');
        if (q) { e.preventDefault(); var li = q.closest('[data-key]'); var n = parseInt(li.getAttribute('data-qty'), 10) + (q.getAttribute('data-zmc-qty') === 'up' ? 1 : -1); self.change(li.getAttribute('data-key'), Math.max(0, n)); return; }
        var rm = e.target.closest('[data-zmc-remove]');
        if (rm) { e.preventDefault(); self.change(rm.closest('[data-key]').getAttribute('data-key'), 0); return; }
        var add = e.target.closest('[data-zmc-add]');
        if (add) { e.preventDefault(); add.disabled = true; self.addId(add.getAttribute('data-zmc-add'), 1).finally(function () { add.disabled = false; }); }
      });
      this.addEventListener('change', function (e) {
        var up = e.target.closest('[data-zmc-upsell]');
        if (!up) return;
        var id = up.getAttribute('data-zmc-upsell');
        if (up.checked) self.addId(id, 1, true);
        else { var it = (self.cart && self.cart.items || []).find(function (i) { return String(i.variant_id) === id; }); if (it) self.change(it.key, 0); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.hidden) self.close(); });

      /* otvaranje preko ikone košarice */
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href$="/cart"], a[href="/cart"], #cart-icon-bubble, [data-zmc-open]');
        if (!a || self.contains(a) || e.metaKey || e.ctrlKey) return;
        e.preventDefault(); e.stopPropagation(); self.open();
      }, true);

      /* sve forme za dodavanje u košaricu */
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.action || !/\/cart\/add/.test(f.action) || self.contains(f)) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var btn = f.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        self.addForm(f).finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
      }, true);

      this.fetchCart().then(function (c) { self.updateBubble(c.item_count); });
      this.watchAnn();
    }

    /* traka u košarici prati traku obavijesti: akcija ako je aktivna, inače trenutno aktivna poruka */
    watchAnn() {
      var self = this, bar = document.querySelector('.zm-ann');
      if (!this.$('[data-zmc-ann]') || !bar || this._annObs) return;
      this._annObs = new MutationObserver(function () {
        if (self.hidden || self._annRaf) return;
        self._annRaf = requestAnimationFrame(function () { self._annRaf = 0; self.syncAnn(); });
      });
      this._annObs.observe(bar, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    }

    syncAnn() {
      var strip = this.$('[data-zmc-ann]'); if (!strip) return;
      var bar = document.querySelector('.zm-ann');
      var src = bar && (bar.querySelector('[data-ak-msg]:not([hidden])') || bar.querySelector('.zm-ann__msg.is-active:not([hidden])') || bar.querySelector('.zm-ann__msg:not([hidden])'));
      if (!src || !src.textContent.trim()) { strip.hidden = true; return; }
      var cs = getComputedStyle(bar);
      strip.style.backgroundColor = cs.backgroundColor;
      strip.style.backgroundImage = cs.backgroundImage;
      strip.style.color = cs.color;
      if (strip.innerHTML !== src.innerHTML) strip.innerHTML = src.innerHTML;
      strip.hidden = false;
    }

    money(cents) {
      var fmt = this.cfg.moneyFormat || '€{{amount_with_comma_separator}}';
      var v = (cents / 100);
      var withSep = function (n, d, t, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return withSep(v, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return withSep(v, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return withSep(v, 0, '.', ',');
        return withSep(v, 2, ',', '.');
      });
    }

    fetchCart() {
      var self = this;
      return fetch((this.cfg.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { self.cart = c; return c; });
    }

    loading(on) { var l = this.$('[data-zmc-loading]'); if (l) l.hidden = !on; }

    toast(msg) {
      var t = this.$('[data-zmc-toast]'); if (!t) return;
      t.textContent = msg; t.hidden = false; clearTimeout(this._tt);
      this._tt = setTimeout(function () { t.hidden = true; }, 4000);
    }

    open() {
      var self = this;
      this._last = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add('zmc-lock');
      this.watchAnn(); this.syncAnn();
      requestAnimationFrame(function () { self.classList.add('is-open'); self.panel.focus(); });
      return this.refresh();
    }

    close() {
      var self = this;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('zmc-lock');
      setTimeout(function () { self.hidden = true; if (self._last && self._last.focus) self._last.focus(); }, 280);
    }

    refresh() {
      var self = this;
      return this.fetchCart().then(function (c) { self.render(c); return c; });
    }

    after(res) {
      var self = this;
      return res.json().then(function (data) {
        if (res.status >= 400 || data.status) { self.toast(data.description || data.message || 'Nije moguće dodati proizvod.'); throw data; }
        return data;
      });
    }

    addForm(form) {
      var self = this;
      this.loading(true);
      return fetch((this.cfg.root || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(this.after.bind(this))
        .then(function () { return self.cfg.openOnAdd === false ? self.refresh() : self.open(); })
        .then(function () { self.later(); })
        .catch(function () {})
        .finally(function () { self.loading(false); });
    }

    addId(id, qty, silent) {
      var self = this;
      this.loading(true);
      return fetch((this.cfg.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
        .then(this.after.bind(this))
        .then(function () { return self.hidden && !silent ? self.open() : self.refresh(); })
        .then(function () { self.later(); })
        .catch(function () {})
        .finally(function () { self.loading(false); });
    }

    change(key, qty) {
      var self = this;
      this.loading(true);
      return fetch((this.cfg.root || '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(this.after.bind(this))
        .then(function (c) { self.cart = c; self.render(c); self.later(); })
        .catch(function () { self.refresh(); })
        .finally(function () { self.loading(false); });
    }

    /* aplikacije (npr. automatski poklon) mijenjaju košaricu nakon nas */
    later() { var self = this; clearTimeout(this._lt); this._lt = setTimeout(function () { self.refresh(); }, 1200); }

    updateBubble(n) {
      document.querySelectorAll('#cart-icon-bubble').forEach(function (b) {
        var bub = b.querySelector('.cart-count-bubble');
        if (n > 0) {
          if (!bub) { bub = document.createElement('div'); bub.className = 'cart-count-bubble'; b.appendChild(bub); }
          bub.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '') + '</span><span class="visually-hidden">' + n + ' artikala</span>';
        } else if (bub) bub.remove();
      });
      document.dispatchEvent(new CustomEvent('zm:cart:updated', { detail: this.cart }));
    }

    word(n) { var w = this.cfg.countWord || ['proizvod', 'proizvoda', 'proizvoda']; var m10 = n % 10, m100 = n % 100; return (m10 === 1 && m100 !== 11) ? w[0] : w[1]; }

    render(c) {
      var self = this;
      this.updateBubble(c.item_count);
      var empty = c.item_count === 0;
      this.$('[data-zmc-count]').textContent = empty ? '' : '(' + c.item_count + ')';
      this.$('[data-zmc-empty]').hidden = !empty;
      this.$('[data-zmc-foot]').hidden = empty;

      /* napredak besplatne dostave */
      var prog = this.$('[data-zmc-progress]');
      var t1 = this.cfg.freeShip || 0, t2 = this.cfg.gift || 0, tot = c.total_price;
      if (prog && t1 > 0) {
        prog.hidden = false;
        var max = t2 > t1 ? t2 : t1;
        this.$('[data-zmc-fill]').style.width = Math.min(100, tot / max * 100) + '%';
        var msg;
        if (tot < t1) msg = (this.cfg.shipLeft || '').replace('{amount}', '<b>' + this.money(t1 - tot) + '</b>');
        else if (t2 > t1 && tot < t2) msg = (this.cfg.giftLeft || '').replace('{amount}', '<b>' + this.money(t2 - tot) + '</b>');
        else msg = '<b>' + esc(t2 > t1 ? this.cfg.giftDone : this.cfg.shipDone) + '</b>';
        this.$('[data-zmc-msg]').innerHTML = msg;
        prog.querySelectorAll('[data-zmc-mile]').forEach(function (m) { m.classList.toggle('is-done', tot >= (m.getAttribute('data-zmc-mile') === '2' ? t2 : t1)); });
      }

      /* stavke */
      this.$('[data-zmc-items]').innerHTML = c.items.map(function (i) {
        var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
        var variant = i.variant_title && !/^Default/.test(i.variant_title) ? '<span class="zmc__var">' + esc(i.variant_title) + '</span>' : '';
        var props = '';
        if (i.properties) Object.keys(i.properties).forEach(function (k) { if (k.charAt(0) !== '_' && i.properties[k]) props += '<span class="zmc__var">' + esc(k) + ': ' + esc(i.properties[k]) + '</span>'; });
        var disc = (i.line_level_discount_allocations || []).map(function (d) { return '<span class="zmc__tag">' + esc(d.discount_application.title) + ' (−' + self.money(d.amount) + ')</span>'; }).join('');
        var was = i.original_line_price > i.final_line_price ? '<s>' + self.money(i.original_line_price) + '</s>' : '';
        var free = i.final_line_price === 0 && i.original_line_price > 0;
        return '<li class="zmc__item" data-key="' + esc(i.key) + '" data-qty="' + i.quantity + '">' +
          '<a class="zmc__img" href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="90" height="90">' : '') + '</a>' +
          '<div class="zmc__info">' +
            '<a class="zmc__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant + props + disc +
            '<div class="zmc__row">' +
              '<div class="zmc__qty"><button type="button" data-zmc-qty="down" aria-label="Smanji količinu">−</button><span>' + i.quantity + '</span><button type="button" data-zmc-qty="up" aria-label="Povećaj količinu">+</button></div>' +
              '<div class="zmc__price">' + (free ? '<b class="zmc__free">GRATIS</b>' : '<b>' + self.money(i.final_line_price) + '</b>') + was + '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="zmc__rm" data-zmc-remove aria-label="' + esc(self.cfg.removeLabel || 'Ukloni') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></button>' +
        '</li>';
      }).join('');

      /* popusti na razini košarice */
      var cd = (c.cart_level_discount_applications || []).map(function (d) { return '<div><span>' + esc(d.title) + '</span><span>−' + self.money(d.total_allocated_amount) + '</span></div>'; }).join('');
      var cdEl = this.$('[data-zmc-cartdisc]'); if (cdEl) cdEl.innerHTML = cd;

      this.$('[data-zmc-total]').textContent = this.money(c.total_price);
      this.$('[data-zmc-total-was]').textContent = c.original_total_price > c.total_price ? this.money(c.original_total_price) : '';
      this.$('[data-zmc-total-count]').textContent = '(' + c.item_count + ' ' + this.word(c.item_count) + ')';

      var up = this.$('[data-zmc-upsell]');
      if (up) up.checked = c.items.some(function (i) { return String(i.variant_id) === up.getAttribute('data-zmc-upsell'); });

      this.renderRecs(c);
    }

    getRecs(pid, intent) {
      var key = pid + ':' + intent;
      if (this.recsCache[key]) return this.recsCache[key];
      var url = (this.cfg.recsUrl || '/recommendations/products') + '.json?product_id=' + pid + '&limit=10&intent=' + intent;
      this.recsCache[key] = fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) { return d.products || []; }).catch(function () { return []; });
      return this.recsCache[key];
    }

    renderRecs(c) {
      var self = this;
      var box = this.$('[data-zmc-recs]'), list = this.$('[data-zmc-recs-list]');
      var h = box.querySelector('.zmc__recs-h'), sub = box.querySelector('.zmc__recs-s');
      if (h && !h._t) { h._t = h.textContent; }
      var isEmpty = !c.items.length;
      if (h) h.textContent = isEmpty ? (this.cfg.emptyRecs || 'Najprodavaniji proizvodi') : h._t;
      if (sub) sub.hidden = isEmpty;
      var limit = this.cfg.recsLimit || 4;
      var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
      var seeds = []; c.items.forEach(function (i) { if (i.final_line_price > 0 && seeds.indexOf(i.product_id) < 0) seeds.push(i.product_id); });
      seeds = seeds.slice(0, 3);
      var token = (this._rt = (this._rt || 0) + 1);
      var jobs = [];
      seeds.forEach(function (p) { jobs.push(self.getRecs(p, 'complementary')); });
      seeds.forEach(function (p) { jobs.push(self.getRecs(p, 'related')); });
      Promise.all(jobs).then(function (lists) {
        if (token !== self._rt) return;
        var out = [], seen = {};
        lists.concat([self.cfg.fallback || []]).forEach(function (l) { l.forEach(function (p) { if (!seen[p.id] && !inCart[p.id] && p.available) { seen[p.id] = 1; out.push(p); } }); });
        out = out.slice(0, limit);
        box.hidden = !out.length;
        list.innerHTML = out.map(function (p) {
          var v = (p.variants || []).find(function (x) { return x.available; }) || p.variants[0];
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          var was = p.compare_at_price > p.price ? '<s>' + self.money(p.compare_at_price) + '</s>' : '';
          return '<li class="zmc__rec">' +
            '<a class="zmc__rec-img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
            '<div class="zmc__rec-i"><a href="' + esc(p.url) + '" class="zmc__rec-t">' + esc(p.title) + '</a><span class="zmc__rec-p"><b>' + self.money(p.price) + '</b>' + was + '</span>' + (p.compare_at_price > p.price ? '<span class="zm-sid zm-sid--om">Najniža cijena u zadnjih 30 dana: <b>' + self.money(p.compare_at_price) + '</b></span>' : '') + '</div>' +
            '<button type="button" class="zmc__btn zmc__btn--sm" data-zmc-add="' + v.id + '">' + esc(self.cfg.addLabel || 'Dodaj') + '</button>' +
          '</li>';
        }).join('');
      });
    }
  }
  customElements.define('zm-cart-drawer', ZMCart);
})();